export default __webpack_public_path__ + "static/media/Lato-Light.2108ed7c.woff2";